import { connect } from 'react-redux';

import { FORM_ERROR } from 'final-form';
import { Dispatch } from 'redux';

import { FETCH_ERROR } from '@nord/tool.redux-api/es/actionTypes';

import fetchErrorFromResponse from '../../../tools/fetchErrorFromResponse';
import { IReduxAction } from '../../../types';
import Form, { IForgotPasswordValues } from '../../components/templates/ForgotPassword';
import { isLoggedIn } from '../../store/selectors';

interface IForgotPasswordState {
  loggedIn: boolean;
}

interface IForgotPasswordOwnProps {
  submitAction: (values: IForgotPasswordValues) => IReduxAction;
}

const mapStateToProps = (state: IForgotPasswordState) => ({
  loggedIn: isLoggedIn(state),
});

const mapDispatchToProps = (dispatch: Dispatch, { submitAction }: IForgotPasswordOwnProps) => ({
  onSubmit: async (values: IForgotPasswordValues) => {
    const {
      type,
      payload: { errorResponse },
    } = await dispatch(submitAction(values));

    return (
      type === FETCH_ERROR && {
        [FORM_ERROR]: fetchErrorFromResponse(errorResponse),
      }
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
